import { errorTypes } from "./ViewPageError.constants";

export const getErrorType = (
  isStudent,
  isAuthenticated,
  statusCode,
  isLiteUser,
) => {
  if (!isAuthenticated) {
    return statusCode === 401
      ? errorTypes.UNAUTHENTICATED_USER_RESTRICTED_CONTENT
      : errorTypes.UNAUTHENTICATED_USER_FREE_CONTENT;
  } else {
    switch (statusCode) {
      case 200:
        if (isStudent && isLiteUser) {
          return errorTypes.STUDENT_USER_UNLICENSED_CONTENT;
        } else {
          break;
        }
      case 403:
        return isStudent
          ? errorTypes.STUDENT_USER_RESTRICTED_CONTENT
          : errorTypes.NON_STUDENT_USER_RESTRICTED_CONTENT;
      case 451:
        return errorTypes.AUTHENTICATED_USER_DISTRICT_RESTRICTED_CONTENT;
    }
  }

  return errorTypes.GENERIC;
};
